import { render, staticRenderFns } from "./object-detail-type-form.vue?vue&type=template&id=8c504cf2&scoped=true&"
import script from "./object-detail-type-form.vue?vue&type=script&lang=js&"
export * from "./object-detail-type-form.vue?vue&type=script&lang=js&"
import style0 from "./object-detail-type-form.vue?vue&type=style&index=0&id=8c504cf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c504cf2",
  null
  
)

export default component.exports